export default __webpack_public_path__ + "static/media/Headdress of the Blue Sea (Male Version).2eed6fbc.jpg";